import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { getOnboardingCallLink } from '../../../self-upgrade.util';

export const PRACTICE_ANALYTICS_VIDEO_URL = 'https://fast.wistia.com/embed/medias/ymxr76flgk';
export const PRACTICE_ANALYTICS_ONBOARDING_URL = getOnboardingCallLink(Feature.PRACTICE_ANALYTICS);
export const PRACTICE_ANALYTICS_PRICE = 199;
